import { render, staticRenderFns } from "./AdminLegal.vue?vue&type=template&id=3e8ebaa6&"
import script from "./AdminLegal.vue?vue&type=script&lang=js&"
export * from "./AdminLegal.vue?vue&type=script&lang=js&"
import style0 from "./AdminLegal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports